import Vuex from 'vuex' ;
import Vue from 'vue' ;
import stores from "./stores";

Vue.use(Vuex);
export default new Vuex.Store(stores);